// CSV exports open in Excel or Sheets, where a cell starting with = + - @ (or a tab / return) runs
// as a formula. Names, emails and notes come from public forms, lead ads and WhatsApp, so a
// "first name" of =HYPERLINK(…) must stay text: such a cell gets a leading ' (shown as plain text).
// A plain number, like -5.00, is left alone so money columns stay numbers.
export const safeCell = (v: string) => (/^[=+\-@\t\r]/.test(v) && !/^[-+]?\d+(\.\d+)?$/.test(v) ? `'${v}` : v);

/** csv-stringify's `cast` for strings. A cast of your own that returns text must call safeCell itself. */
export const safeCast = { string: safeCell };

/** Imports: the separator the header row uses. Excel in much of Europe saves CSV with semicolons,
 *  and "Text (tab delimited)" uses tabs; a comma file is the default. */
export function delimiterOf(csv: string) {
  const head = csv.slice(0, csv.search(/\r?\n|$/)).replace(/"[^"]*"/g, '');
  const count = (d: string) => head.split(d).length;
  return [',', ';', '\t'].reduce((best, d) => (count(d) > count(best) ? d : best), ',');
}
